/**
 * Component to redirect users to the profile page
 * */
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import roleDisabled from 'services/roleDisabled/index';
import {
  OWNER,
  OR_ADMIN,
  OR_SUPERUSER,
  OR_READONLY,
  OR_SUPERREAD,
  ADMIN,
  READONLY,
  BILLING,
} from 'constants/roles';

const propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  userRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
};

function InstancesPageRedirect({ location, userRoles }) {
  const allowedUserRoles = [
    OWNER,
    OR_ADMIN,
    OR_SUPERUSER,
    OR_READONLY,
    OR_SUPERREAD,
    ADMIN,
    READONLY,
    BILLING,
  ];
  return (
    <Redirect
      to={{
        pathname: roleDisabled(userRoles, allowedUserRoles)
          ? '/mission-ctrl/profile'
          : '/mission-ctrl/instances',
        state: { from: location.pathname },
      }}
    />
  );
}

InstancesPageRedirect.propTypes = propTypes;

export default InstancesPageRedirect;
